import * as React from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

export default function DeletableChips(props) {
  const { chipKey, chipValue, deleteChip } = props;
  const handleDelete = () => {
    deleteChip(chipKey);
  };

  return (
    <Stack direction="row" spacing={5} style={{ paddingRight: '5px' }}>
      <Chip
        label={chipValue}
        variant="filled"
        size="small"
        onDelete={handleDelete}
      />
    </Stack>
  );
}
